var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-detail"},[_c('h2',[_vm._v("全体連絡 詳細")]),_c('NotificationEditor',{attrs:{"notificationId":_vm.notificationId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }